module.exports = __webpack_public_path__ + "static/media/explore_text.5c0a05d7.jpg";